import { render, staticRenderFns } from "./NewBlockButton.vue?vue&type=template&id=0f7aef0e&scoped=true&lang=pug&"
import script from "./NewBlockButton.vue?vue&type=script&lang=js&"
export * from "./NewBlockButton.vue?vue&type=script&lang=js&"
import style0 from "./NewBlockButton.vue?vue&type=style&index=0&id=0f7aef0e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7aef0e",
  null
  
)

export default component.exports